import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
        <path
          d="M28 61 L28 30 L36 30 L50 55 L50 30 L56 30 L56 61 L48 61 L34 36 L34 61 Z"
          fill="currentColor"
          transform="translate(-3, 0)"
        />
      </g>
    </g>
  </svg>
);

export default IconLogo;
